import { render } from "./CheckoutOkView.vue?vue&type=template&id=c8d8d57a&scoped=true&ts=true"
import script from "./CheckoutOkView.vue?vue&type=script&lang=ts"
export * from "./CheckoutOkView.vue?vue&type=script&lang=ts"

import "./CheckoutOkView.vue?vue&type=style&index=0&id=c8d8d57a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8d8d57a"]])

export default __exports__